import logo from './logo.svg';
import './App.css';
import HospitalSearch from './components/HospitalSearch';
import useStore from './store';
import { useEffect, useRef, useCallback } from 'react';
import Hospital from './components/Hospital';
import { useInView } from "react-intersection-observer";
import DataDetails from './components/DataDetails';


function App() {

  const { ref, inView } = useInView({
    threshold: 0.1,
  });

  const postcodeUser = useStore((state) => state.postcodeUser);
  const suburbUser = useStore((state) => state.suburbUser);
  const postcodeUserLong = useStore((state) => state.postcodeUserLong);
  const postcodeUserLat = useStore((state) => state.postcodeUserLat);

  const postcodeSelected = useStore((state) => state.postcodeSelected);

  // const stateCode = useStore((state) => state.stateCode);

  const hospitalData = useStore((state) => state.hospitals);

  // const nswHospitals = useStore((state) => state.nswHospitals);
  // const setNswHospitals = useStore((state) => state.setNswHospitals);

  // const actHospitals = useStore((state) => state.actHospitals);
  // const setActHospitals = useStore((state) => state.setActHospitals);

  // const qldHospitals = useStore((state) => state.qldHospitals);
  // const setQldHospitals = useStore((state) => state.setQldHospitals);

  // const vicHospitals = useStore((state) => state.vicHospitals);
  // const setVicHospitals = useStore((state) => state.setVicHospitals);

  // const tasHospitals = useStore((state) => state.tasHospitals);
  // const setTasHospitals = useStore((state) => state.setTasHospitals);

  // const ntHospitals = useStore((state) => state.ntHospitals);
  // const setNtHospitals = useStore((state) => state.setNtHospitals);

  // const waHospitals = useStore((state) => state.waHospitals);
  // const setWaHospitals = useStore((state) => state.setWaHospitals);

  // const saHospitals = useStore((state) => state.saHospitals);
  // const setSaHospitals = useStore((state) => state.setSaHospitals);

  const completeHospitals = useStore((state) => state.completeHospitals);
  const setCompleteHospitals = useStore((state) => state.setCompleteHospitals);

  const emergencyDepartmentHospitals = useStore((state) => state.emergencyDepartmentHospitals);
  const setEmergencyDepartmentHospitals = useStore((state) => state.setEmergencyDepartmentHospitals);

  const electiveSurgeryHospitals = useStore((state) => state.electiveSurgeryHospitals);
  const setElectiveSurgeryHospitals = useStore((state) => state.setElectiveSurgeryHospitals);

  const partialServiceHospitals = useStore((state) => state.partialServiceHospitals);
  const setPartialServiceHospitals = useStore((state) => state.setPartialServiceHospitals);

  const visibleItems = useStore((state) => state.visibleItems);
  const setVisibleItems = useStore((state) => state.setVisibleItems);

  const setDataDetails = useStore((state) => state.setDataDetails);

  useEffect(() => {
    hospitalData.forEach(hospital => {
      const type = hospital.type;
      switch (true) {
        case type === "Complete":
          setCompleteHospitals(hospital);
          break;
        case type === "Emergency":
          setEmergencyDepartmentHospitals(hospital);
          break;
        case type === "Elective Surgery":
          setElectiveSurgeryHospitals(hospital);
          break;
        case type === "Community":
          setPartialServiceHospitals(hospital);
          break;
        default:
          // Handle cases where no match is found if necessary
          break;
      }
    });
  }, [hospitalData])

  // const hospitalsByState = {
  //   ACT: actHospitals,
  //   NSW: nswHospitals,
  //   QLD: qldHospitals,
  //   VIC: vicHospitals,
  //   TAS: tasHospitals,
  //   NT: ntHospitals,
  //   WA: waHospitals,
  //   SA: saHospitals
  // };

  const hospitalsByType = {
    Complete: completeHospitals,
    Emergency: emergencyDepartmentHospitals,
    Elective: electiveSurgeryHospitals,
    Community: partialServiceHospitals
  };

  // distance calc for each hospital
  function haversineDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers
    return distance;
  }

  const loadMoreItems = useCallback(() => {
    // console.log('here')
    if (inView) {
      setVisibleItems(visibleItems + 5);
    }
  }, [inView]);

  const calculateDistances = (hospitals, userLat, userLong) => {
    return hospitals.map(hospital => ({
      ...hospital,
      distance: Math.round(haversineDistance(userLat, userLong, hospital.latitude, hospital.longitude))
    }));
  };

  const renderHospital = (hospital, index) => (
    <Hospital
      distance={hospital.distance}
      name={hospital.name}
      type={hospital.type}
      address={hospital.address}
      long={hospital.longitude}
      lat={hospital.latitude}
      edResuscitation={hospital.edResuscitation}
      edResuscitationTraffic={hospital.edResuscitationTraffic}
      edEmergency={hospital.edEmergency}
      edEmergencyTraffic={hospital.edEmergencyTraffic}
      edUrgent={hospital.edUrgent}
      edUrgentTraffic={hospital.edUrgentTraffic}
      edSemiUrgent={hospital.edSemiUrgent}
      edSemiUrgentTraffic={hospital.edSemiUrgentTraffic}
      edNonUrgent={hospital.edNonUrgent}
      edNonUrgentTraffic={hospital.edNonUrgentTraffic}
      urgentElectiveSurgery={hospital.urgentElectiveSurgery}
      urgentElectiveSurgeryTraffic={hospital.urgentElectiveSurgeryTraffic}
      semiUrgentElectiveSurgery={hospital.semiUrgentElectiveSurgery}
      semiUrgentElectiveTraffic={hospital.semiUrgentElectiveTraffic}
      nonUrgentElectiveSurgery={hospital.nonUrgentElectiveSurgery}
      nonUrgentElectiveSurgeryTraffic={hospital.nonUrgentElectiveSurgeryTraffic}
      key={index}
    />
  );

  const isSelected = () => {
    if (postcodeSelected && hospitalsByType.Complete.length > 0) {
      const allHospitalsWithDistances = [
        ...calculateDistances(hospitalsByType['Complete'], postcodeUserLat, postcodeUserLong),
        ...calculateDistances(hospitalsByType['Emergency'], postcodeUserLat, postcodeUserLong),
        // ...calculateDistances(hospitalsByType['Elective'], postcodeUserLat, postcodeUserLong),
        ...calculateDistances(hospitalsByType['Community'], postcodeUserLat, postcodeUserLong)
      ];
      
      const electiveSurgeryHospitals = calculateDistances(hospitalsByType['Elective'], postcodeUserLat, postcodeUserLong)
      const sortedElectiveSurgeryHospitals = electiveSurgeryHospitals.sort((a, b) => a.distance - b.distance);
      console.log('fourthHospital', sortedElectiveSurgeryHospitals[0].distance);
      

      const sortedHospitals = allHospitalsWithDistances.sort((a, b) => a.distance - b.distance);

      const closestHospital = sortedHospitals[0];
      let secondHospital, thirdHospital;

      if (closestHospital.type === 'Complete') {
        secondHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital);
        thirdHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital && h !== secondHospital);
      } else if (closestHospital.type === 'Emergency') {
        secondHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital);
        thirdHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital && h !== secondHospital);
      } else if (closestHospital.type === 'Community') {
        let index = 1;
        while (sortedHospitals[index] && sortedHospitals[index].type === 'Community') {
          index++;
        }
        secondHospital = sortedHospitals[index];

        if (secondHospital && secondHospital.type === 'Complete') {
          thirdHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital && h !== secondHospital);
        } else if (secondHospital && secondHospital.type === 'Emergency') {
          thirdHospital = sortedHospitals.find(h => h.type === 'Complete' && h !== closestHospital && h !== secondHospital);
        }
      }

      return (
        <>
          <div>
            <h3 className='text-xs mb-3'><span className='font-semibold'>Disclaimer:</span> The distance between your postcode and the hospitals is an approximation and should only be used as a guide.</h3>
            {renderHospital(closestHospital)}
            {secondHospital && renderHospital(secondHospital)}
            {thirdHospital && renderHospital(thirdHospital)}
            {sortedElectiveSurgeryHospitals?.[0]?.distance <= 500 && renderHospital(sortedElectiveSurgeryHospitals[0])}
          </div>
        </>
      );
    }
  };

  const notSelected = () => {
    return (
      <>
        {hospitalData.slice(0, visibleItems).map(renderHospital)}
        <div ref={ref} onLoad={loadMoreItems()}></div>
      </>

    )
  }

  const returnUserLocation = () => {
    const locationContent = postcodeUser ? (
      <p>{suburbUser} {postcodeUser}</p>
    ) : (
      <p className="text-gray-300">Enter postcode</p>
    );

    return (
      <div className={`text-sm font-medium flex space-x-1 items-center ${!postcodeUser ? 'text-gray-300' : ''}`}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
          <path d="M480-107q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5q-33.5-53.5-51-103T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 45-17.5 94.5t-51 103Q698-301 648-244T533-127q-11 10-25 15t-28 5Zm0-373q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Z" />
        </svg>
        {locationContent}
      </div>
    );
  };

  return (
    <div className="App space-y-5 text-sm relative overflow-auto">
      <DataDetails />
      <div className='flex justify-between'>
        <h2 className='font-bold text-lg'>Hospital logjam finder</h2>
        <p>Is your hospital in logjam?</p>
      </div>
      <HospitalSearch />
      <div className='flex justify-between'>
        <button onClick={() => setDataDetails(true)} className='text-sm underline'>Details about this data</button>
        <div>{returnUserLocation()}</div>
      </div>
      <div className='h-[400px] overflow-auto space-y-3'>
        {isSelected() && isSelected()} {/* Render isSelected only if it returns a truthy value */}
        {!isSelected() && notSelected()} {/* Render notSelected only if isSelected returns a falsy value */}

      </div>
    </div>
  );
}

export default App;
